import React, { useEffect } from "react";
import { ReviewCard } from "./ReviewCard";
import {
  Box,
  CircularProgress,
  Divider,
  LinearProgress,
  Rating,
} from "@mui/material";
import { red } from "@mui/material/colors";
import { ReviewRes } from "../../../types/reviewType";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchReviewsByProductId } from "../../../State/customer/ReviewSlice";
import { useParams } from "react-router-dom";

export const Review = () => {
  const dispatch = useAppDispatch()
  const {review} = useAppSelector(store=>store)
  const {productId}= useParams()
  function normalise(value: any): number | undefined {
    throw new Error("Function not implemented.");
  }

  useEffect(() => {  
    dispatch(fetchReviewsByProductId(Number(productId)))
  },[productId])

  return (
    <div className="p-5 lg:px-20 flex flex-col lg:flex-row gap-20 ">
      {/* left side */}
      <section className="w-full md:w-1/2 lg:w-[30%] space-y-2">
       {
        review.reviews&&review.reviews.map((item)=> <div>
          {item.images&& item.images.map((image)=> <img
          src={image}
          alt=""
        />)}
        </div>)
       }
        <div className="">
          <div className="">
            <p className="font-bold text-xl">Nelly Clothing</p>
            <p className="text-lg text-gray-600">Sparkly Women Dress</p>
          </div>
          <div className="">
            <div className="price flex items-center gap-3 mt-5 text-2xl">
              <span className="font-sans text-gray-800">48€</span>
              <span className="line-through text-gray-400">80€</span>
              <span className="text-primary font-semibold ">70%</span>
            </div>
          </div>
        </div>
      </section>
      {/* right side */}
      <section className="w-full space-y-5 ">
        <h1>Review and Ratings</h1>
        <Box sx={{borderRadius:"10px"}} className="pl-10 border flex-col justify-center items-center p-7 ">
          <div className="flex justify-start space-x-5 pb-5">
            <Rating readOnly value={4.5} precision={0.5} />
            <h2 className="text-gray-400">Ratings</h2>
          </div>

       <div className="space-y-7 flex-col flex justify-center items-center">
       <div className="flex w-full  items-center space-x-7">
          <div className="w-[10%]"><p>Excellent</p></div>
          {/* progress bar */}
          <div className="lg:w-[70%] w-[40%]">
            <LinearProgress
            
              sx={{
                "& .MuiLinearProgress-bar": {
                  transition: "none",
                   borderRadius: "10px"
                },
                borderRadius: "10px",
                width:"100%",
                height:"10px"
              }}
              variant="determinate"
              value={70}
              color="success"
            />
          </div>
          <div className=""><p>19256</p></div>
          </div>
          <div className="flex w-full justify-start items-center space-x-7">
          <div className="w-[10%]"><p>Very Good</p></div>
          {/* progress bar */}
          <div className="w-[40%] lg:w-[70%]">
            <LinearProgress
            
              sx={{
                "& .MuiLinearProgress-bar": {
                  transition: "none",
                   borderRadius: "10px"
                },
                borderRadius: "10px",
                height:"10px"
              }}
              variant="determinate"
              value={60}
              color="success"
            />
          </div>
          <p>19256</p>
          </div>
          <div className="flex w-full justify-start items-center space-x-7">
          <div className="w-[10%]"><p>Good</p></div>
          {/* progress bar */}
          <div className="w-[40%] lg:w-[70%]">
            <LinearProgress
            
              sx={{
                "& .MuiLinearProgress-bar": {
                  transition: "none",
                   borderRadius: "10px"
                },
                borderRadius: "10px",
                
                height:"10px"
              }}
              variant="determinate"
              value={40}
            />
          </div>
          <p>19256</p>
          </div>
          <div className="flex w-full justify-start items-center space-x-7">
          <div className="w-[10%]"><p>Average</p></div>
          {/* progress bar */}
          <div className="w-[40%] lg:w-[70%]">
            <LinearProgress
            
              sx={{
                "& .MuiLinearProgress-bar": {
                  transition: "none",
                   borderRadius: "10px",
                   backgroundColor:"#8b5b0f",
                },
                borderRadius: "10px",
                
                height:"10px"
              }}
              variant="determinate"
              value={30}
             
            />
          </div>
          <p>19256</p>
          </div>
          <div className="flex w-full justify-start items-center space-x-7">
          <div className="w-[10%]"><p>Poor</p></div>
          {/* progress bar */}
          <div className="w-[40%] lg:w-[70%]">
            <LinearProgress
            
              sx={{
                "& .MuiLinearProgress-bar": {
                  transition: "none",
                   borderRadius: "10px",
                   backgroundColor:"#cf2a2a"
                },
                borderRadius: "10px",
                
                height:"10px"
              }}
              variant="determinate"
              value={10}
            />
          </div>
          <p>19256</p>
          </div>
       </div>
        </Box>
        {review.reviews.map((_, index) => (
            <div className="space-y-3">
              <ReviewCard review={review.review} />
              <Divider />
            </div>
          ))}
      </section>
    </div>
  );
};
